<template>
  <div id="layout">
    <main style="overflow: hidden">
      <!-- <social-icons></social-icons> -->
      <app-content />
      <footer-bar></footer-bar>
    </main>
  </div>
</template>

<script>
// Layout components
import MenuBar from "@/views/site/blocks/MenuBar";
import FooterBar from "@/views/site/blocks/FooterBar";
// import SocialIcons from "@/views/site/blocks/SocialIcons";
import AppContent from "@/views/site/blocks/AppContent";

export default {
  name: "SiteLayout",
  components: {
    MenuBar,
    FooterBar,
    AppContent,
    // SocialIcons,
  },
};
// Layout components
</script>
